<script context="module">
    import { DirectUserRoles } from "./utilEnums.svelte";

    export const checkIfShowTab = (role, path) => {
        // role 100 - Admin
        // role 90 - Developer
        // role 80 - Manager
        // role 20 - Support
        // role 2 - Doctor
        // role 1 - Patient

        switch (path) {
            case "Admin":
            case "Managers":
            case "Reconciliations":
            case "Announcements":
            case "CompanyDocuments":
            case "OrderProducts":
            case "InProgress":
            case "ConsentDue":
            case "PatientPaymentDue":
            case "UnsentDocuments":
            case "FollowUp":
            case "ClaimError":
            case "Underpaid":
            case "Overpaid":
            case "PendingRefund":
            case "PendingReview":
            case "SupportStaff":
            case "DebtCollection":
            case "OnHoldAndRemoved":
            case "LoginLogs":
            case "UnauthorisedLogs":
                return role === 100;

            case "ExceptionLogs":
                return role >= 90;

            case "CalendarCategories":
            case "GlobalEvents":
                return role >= 80;

            case "Account":
            case "Patient":
            case "AllProviders":
            case "InsuranceFunds":
            case "WorkCoverAuthorities":
            case "TrafficAccidentAuthorities":
            case "Hospitals":
            case "MBSItems":
            case "ASAItems":
            case "PublicHolidays":
                return role >= 20;

            case "AccountUsage":
            case "AccountInvoice":
                return role >= 20 && role != 80 && role != 90;

            case "PreOpInstructions":
            case "PreOpQuestionnaires":
            case "EmailTemplates":
            case "SmsTemplates":
            case "PdfTemplates":
                return role >= 2 && role != 90;

            case "ActivityLogs":
            case "EclipseLogs":
                return role >= 2;

            case "AccountSchedules":
            case "BupaPracticeIds":
            case "GlobalEvents":
                return role == 100 || role == 80 || role == 20;

            case "Groups":
            case "GroupInvoices":
                return role == 100 || role == 20;

            case "DefaultFilters":
            case "SurgeryRooms":
            case "BupaPractices":
            case "PortalCustomisation":
                return role == 100 || role == 80;

            case "ExternalGroups":
                // return true;
                return (
                    window.location.hostname.split(".")[0] === "app" &&
                    (role == 100 || role == 20)
                );

            case "Reports":
                return (
                    role == DirectUserRoles.Admin ||
                    role == DirectUserRoles.Manager ||
                    role == DirectUserRoles.Doctor
                );
            // Remove domain restrictions and allow Manager access to reports
            // return (
            //     (window.location.hostname.split(".")[0] === "app" ||
            //         window.location.hostname.split(".")[0] === "new") &&
            //     role === DirectUserRoles.Admin
            // );

            case "BillingRules":
            case "AccountPresets":
            case "ThirdPartyInsurer":
            case "MyInvoice":
                return role == 2;

            // Everyone
            case "Estimates":
            case "Invoices":
            case "PatientEncounter":
            case "PatientQuote":
            case "Receipts":
            case "Calendar":
            case "DailyPlanner":
            default:
                return true;
        }
    };

    export const isEnvNewOrApp = () =>
        window.location.hostname.includes("localhost") || //for local host development
        window.location.hostname.split(".")[0] === "app" ||
        window.location.hostname.split(".")[0] === "new";
 
    export const isEnvApp = () =>
        window.location.hostname.split(".")[0] === "app";

    export const checkEnvIsGroup = (envSettings) => {
        if(envSettings && envSettings.isGroup && envSettings.isGroup == true){
            return true;
        }
        return false;
    }
</script>
